// @react/hooks/useAffiliate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { affiliateStore } from '@core/stores';

/**
 * React hook for Affiliate operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAffiliate } from '@react/hooks';
 *
 * const AffiliateList = observer(() => {
 *   const store = useAffiliate();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useAffiliate() {
  return affiliateStore;
}
